"use client";
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Header from "./Header";
import Footer from "./Footersection";

const Cancellation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <header className="w-full">
        <Header />
      </header>

      <main className="flex-1 w-full">
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
        >
          <section className="bg-gray-50 rounded-2xl shadow-sm overflow-hidden">
            <div className="py-8 px-6 md:px-10 lg:px-12">
              {/* Heading */}
              <div className="flex flex-col items-center gap-4 mb-8">
                <img
                  src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/602ab5c89aae71bf9fd0b889c5d6d9fdf098545c?placeholderIfAbsent=true"
                  alt="ONE-STEP Logo"
                  className="w-14 h-14 rounded-full object-cover"
                />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center">
                  Cancellation & Refund Policy
                </h1>
                <p className="text-sm sm:text-base text-gray-600 text-center max-w-2xl">
                  Thank you for shopping with <strong>ONE STOP WEDDING DRESSES</strong> ("we", "our", "us").
                  We sell sarees and photoshoot costumes through our website. Please read our Cancellation & Refund
                  Policy carefully before placing an order.
                </p>
              </div>

              {/* Card */}
              <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
                {/* Policy content grid: single column on small, two-column on larger screens for better reading */}
                <div className="grid grid-cols-1 gap-6 md:grid-cols-1 lg:grid-cols-1">
                  {/* Order Cancellation */}
                  <div>
                    <h2 className="text-xl sm:text-2xl font-semibold text-center text-gray-800 mb-4">
                      1. Order Cancellation
                    </h2>

                    <div className="space-y-4">
                      <div>
                        <p className="font-semibold text-lg sm:text-xl">Customer-initiated cancellation (before dispatch)</p>
                        <ul className="list-disc pl-5 mt-2 space-y-2 text-gray-700">
                          <li>Orders can be cancelled within <strong>12 hours</strong> of placing the order*, provided the order has not yet been dispatched.</li>
                          <li>To cancel your order, contact us immediately at <strong>+91 83339 22444</strong> with your Order ID.</li>
                          <li>If the order is successfully cancelled before dispatch, we will issue a full refund (after deducting any payment gateway charges, if applicable).</li>
                        </ul>
                      </div>

                      <div>
                        <p className="font-semibold text-lg sm:text-xl">Cancellation after dispatch</p>
                        <ul className="list-disc pl-5 mt-2 space-y-2 text-gray-700">
                          <li>Once the order is dispatched, it <strong>cannot be cancelled</strong>.</li>
                          <li>You may still be eligible for a return or exchange as per our Return Policy below.</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Return & Exchange */}
                  <div>
                    <h2 className="text-xl sm:text-2xl font-semibold text-center text-gray-800 mb-4">
                      2. Return & Exchange Policy
                    </h2>

                    <div className="space-y-4 text-gray-700">
                      <p>Because we sell sarees and photoshoot costumes, we maintain strict quality standards.</p>

                      <div>
                        <p className="font-semibold text-lg sm:text-xl">1. Eligible reasons for return/exchange</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>You received a damaged product.</li>
                          <li>You received a wrong product / wrong design / wrong size compared to your order.</li>
                          <li>There is a major manufacturing defect.</li>
                        </ul>
                      </div>

                      <div>
                        <p className="font-semibold text-lg sm:text-xl">2. Non-returnable / non-refundable items</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>Products that have been used, worn, washed, altered, or damaged by the customer.</li>
                          <li>Products with tags removed, blouse pieces cut, or falls/pico done after delivery.</li>
                          <li>Customized / stitched / made-to-measure outfits.</li>
                          <li>Items bought during sale, clearance, or special promotion, unless they are damaged or incorrect.</li>
                        </ul>
                      </div>

                      <div>
                        <p className="font-semibold text-lg sm:text-xl">3. Time window</p>
                        <p className="mt-1">You must raise a return/exchange request within <strong>12 hours of receiving the product</strong>. Requests made after this period may not be accepted.</p>
                      </div>

                      <div>
                        <p className="font-semibold text-lg sm:text-xl">4. Process for return/exchange</p>
                        <ul className="list-disc pl-4 sm:pl-6 mt-3 space-y-3 text-sm sm:text-base leading-relaxed">
  <li>
    Email us at: <strong>support@onestopweddingdresses.com</strong> or
  </li>

  <li>
    WhatsApp: <strong>+91 83339 22444</strong> with:
    <ul className="list-[square] pl-6 sm:pl-8 mt-2 space-y-2">
      <li>Order ID</li>
      <li>Unboxing video (if possible)</li>
      <li>Clear photos of the product and the defect/issue</li>
    </ul>
  </li>

  <li>
    Our team will review and approve/reject your request within{" "}
    <strong>5 working days</strong>.
  </li>

  <li>Once approved, we will share return shipping instructions.</li>
</ul>

                      </div>

                      <div>
                        <p className="font-semibold text-lg sm:text-xl">5. Return shipping charges</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                        <li>
                          If the product is damaged, defective, or wrong item shipped
by us, we will bear the return shipping cost or arrange
reverse pickup (where available).
                        </li>
                        <li>
                          If the return is requested for personal reasons (e.g., not
liking the color, design change of mind) and if allowed, the
customer must bear the return shipping charges.
                        </li>
                       </ul>
                      </div>
                    </div>
                  </div>

                  {/* Refunds & Contact */}
                  <div>
 <h2 className="text-xl sm:text-2xl font-semibold text-center text-gray-800 mb-4">3.Refund Process

  </h2>

  <div className="space-y-5 text-gray-800">

    {/* 1. Mode of refund */}
    <div>
      <p className="font-semibold text-lg">1. Mode of refund</p>
      <ul className="list-disc pl-6 mt-1 space-y-1">
        <li>
          Refunds (if approved) will be processed to the original payment
          method used at the time of purchase (e.g., card, UPI, wallet), via
          Razorpay / Payment Gateway.
        </li>
      </ul>
    </div>

    {/* 2. Refund timeline */}
    <div>
      <p className="font-semibold text-lg">2. Refund timeline</p>
      <ul className="list-disc pl-6 mt-1 space-y-1">
        <li>
          Once we receive and inspect the returned product, we will initiate
          the refund within 5 working days.
        </li>
        <li>
          Depending on your bank/payment provider, the amount may take
          certain days to reflect in your account.
        </li>
      </ul>
    </div>

    {/* 3. Deductions */}
    <div>
      <p className="font-semibold text-lg">3. Deductions</p>
      <ul className="list-disc pl-6 mt-1 space-y-1">
        <li>
          Original shipping charges (if any) are non-refundable, unless the
          return is due to our error.
        </li>
        <li>
          In some cases, payment gateway fees, COD charges, or reverse pickup
          charges may be deducted if applicable.
        </li>
      </ul>
    </div>

  </div>
</div>


                  <div>
                    <h2 className="text-xl sm:text-2xl font-semibold text-center text-gray-800 mb-4">4. Contact for Cancellation & Refund</h2>
                   <div className="text-gray-700 space-y-3 text-sm sm:text-base leading-relaxed">

  {/* Email */}
  <p className="flex flex-col sm:flex-row sm:items-center gap-1">
    <strong className="sm:min-w-[80px]">Email:</strong>
    <a
      href="mailto:support@onestopweddingdresses.com"
      className="text-blue-600 underline break-all"
    >
      support@onestopweddingdresses.com
    </a>
  </p>

  {/* Phone / WhatsApp */}
  <p className="flex flex-col sm:flex-row sm:items-center gap-1">
    <strong className="sm:min-w-[120px]">Phone/WhatsApp:</strong>
    <a
      href="https://wa.me/918333922444"
      className="text-blue-600 underline"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open WhatsApp chat"
    >
      +91 83339 22444
    </a>
  </p>

  {/* Address */}
  <p className="flex flex-col sm:flex-row sm:items-center gap-1">
    <strong className="sm:min-w-[120px]">Address:</strong>
    <a
      href="https://www.google.com/maps/search/?api=1&query=Vizianagaram,+Andhra+Pradesh+5355006"
      className="text-blue-600 underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      Vizianagaram, Andhra Pradesh - 5355006
    </a>
  </p>

</div>

                  </div>
                </div>
              </div>

            </div>
          </section>
        </motion.div>
      </main>

      <footer className="w-full">
        <Footer />
      </footer>
    </div>
  );
};

export default Cancellation;
